import React from 'react';
import NavbarBlank from '../components/layout/NavbarBlank';
import SignInButton from '../components/layout/SignInButton';
import { useIsAuthenticated } from '@azure/msal-react';
import { Redirect } from 'react-router-dom';

function LoginPage() {
  const isAuthenticated = useIsAuthenticated();
  if (isAuthenticated) {
    return <Redirect to='/home' />;
  } else {
    return (
      <div className='App'>
        <NavbarBlank />
        <div className='container'>
          <SignInButton />
        </div>
      </div>
    );
  }
}

export default LoginPage;
